const Filter = () => {
  const body = document.body;
  const filter = document.querySelector(".filter");
  const filterOpenerBtn = document.querySelector(".filter-btn");
  const fields = document.getElementById("shop-filter-fields");
  const desktopHome = document.querySelector("[data-filter-fields-home]");
  const mobileMount = document.querySelector("[data-filter-fields-mobile]");
  // Matches theme `$max-tablet: 1023px` — mobile/tablet drawer vs desktop sidebar.
  const mobileMq = window.matchMedia("(max-width: 1023px)");

  const placeFilterFields = () => {
    if (!fields || !desktopHome || !mobileMount) {
      return;
    }

    if (mobileMq.matches) {
      if (fields.parentElement !== mobileMount) {
        mobileMount.appendChild(fields);
      }
    } else if (fields.parentElement !== desktopHome) {
      desktopHome.appendChild(fields);
    }
  };

  placeFilterFields();

  if (typeof mobileMq.addEventListener === "function") {
    mobileMq.addEventListener("change", placeFilterFields);
  } else if (typeof mobileMq.addListener === "function") {
    mobileMq.addListener(placeFilterFields);
  }

  const openFilter = () => {
    placeFilterFields();
    if (filterOpenerBtn) {
      filterOpenerBtn.classList.add("opened");
    }
    filter.classList.add("opened");
    body.classList.add("no-scroll");
  };

  const closeFilter = () => {
    if (filterOpenerBtn) {
      filterOpenerBtn.classList.remove("opened");
    }
    filter.classList.remove("opened");
    body.classList.remove("no-scroll");
  };

  if (filterOpenerBtn && filter) {
    filterOpenerBtn.addEventListener("click", () => {
      if (filter.classList.contains("opened")) {
        closeFilter();
      } else {
        openFilter();
      }
    });
  }

  if (filter) {
    const overlay = filter.querySelector(".filter__overlay");
    const closer = filter.querySelector(".filter__close-btn");
    const applyBtn = filter.querySelector(".filter__apply-btn");

    if (overlay) {
      overlay.addEventListener("click", () => {
        closeFilter();
      });
    }

    if (closer) {
      closer.addEventListener("click", () => {
        closeFilter();
      });
    }

    if (applyBtn) {
      applyBtn.addEventListener("click", () => {
        closeFilter();
      });
    }
  }
};

export default Filter;
